import React from 'react'

const VendorBenefitsMailer: React.FC = () => {
  return (
    <div style={{
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      background: "linear-gradient(135deg, #1a5f3f 0%, #2d8f5f 50%, #4cc380 100%)",
      minHeight: "100vh",
      padding: "20px",
      color: "#2c3e50"
    }}>
      <div style={{
        maxWidth: "1200px",
        margin: "0 auto",
        background: "white",
        borderRadius: "25px",
        padding: "40px",
        boxShadow: "0 25px 50px rgba(0, 0, 0, 0.2)"
      }}>
        <div style={{
          textAlign: "center",
          marginBottom: "40px",
          paddingBottom: "30px",
          borderBottom: "3px solid #2d8f5f"
        }}>
          <div style={{ marginBottom: "20px" }}>
            <div style={{
              width: "200px",
              height: "120px",
              margin: "0 auto",
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <img 
                src="/transpdrivelogo.jpg" 
                alt="TranspDrive Logo" 
                style={{ 
                  width: "100%", 
                  height: "100%", 
                  objectFit: "contain",
                  borderRadius: "10px"
                }} 
              />
            </div>
          </div>
          <h1 style={{
            color: "#1a5f3f",
            fontSize: "2.8em",
            marginBottom: "10px",
            fontWeight: 700
          }}>UnbiasedKratom.com</h1>
          <div style={{
            color: "#2d8f5f",
            fontSize: "1.3em",
            fontWeight: 600,
            marginBottom: "15px"
          }}>Partner With The Future of Kratom Industry Standards</div>
          <div style={{
            color: "#666",
            fontSize: "1.1em",
            lineHeight: 1.6,
            maxWidth: "800px",
            margin: "0 auto"
          }}>Join the platform that's elevating vendor accountability, product transparency, and consumer trust across the kratom industry.</div>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
          gap: "25px",
          marginBottom: "30px"
        }}>
          <div style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "15px",
            padding: "25px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
            borderLeft: "6px solid #2d8f5f",
            transition: "all 0.3s ease"
          }}>
            <h3 style={{
              color: "#1a5f3f",
              fontSize: "1.3em",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: 700
            }}>
              <span style={{ fontSize: "1.4em", color: "#2d8f5f" }}>📦</span>
              Product Management System
            </h3>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Individual product pages for every item
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Kratom-specific categorization (7OH Thai/Domestic, MIT Salt/Freebase)
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Effect-based tagging (Sedating, Energetic, Euphoric, Pain Relief)
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Multiple size/price options per product
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Product status management (active/inactive)
              </li>
            </ul>
          </div>

          <div style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "15px",
            padding: "25px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
            borderLeft: "6px solid #2d8f5f",
            transition: "all 0.3s ease"
          }}>
            <h3 style={{
              color: "#1a5f3f",
              fontSize: "1.3em",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: 700
            }}>
              <span style={{ fontSize: "1.4em", color: "#2d8f5f" }}>🔬</span>
              Lab Results & Quality System
            </h3>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Lab result upload and management
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                QR code verification for customers
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Batch tracking system
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Safety testing documentation
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Alkaloid analysis display
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Compliance scoring and tracking
              </li>
            </ul>
          </div>

          <div style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "15px",
            padding: "25px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
            borderLeft: "6px solid #2d8f5f",
            transition: "all 0.3s ease"
          }}>
            <h3 style={{
              color: "#1a5f3f",
              fontSize: "1.3em",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: 700
            }}>
              <span style={{ fontSize: "1.4em", color: "#2d8f5f" }}>🔍</span>
              Search & Discovery Features
            </h3>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Advanced filtering by kratom type, effects, vendor
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Enhanced product visibility
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Featured product highlighting
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Quality-first ranking algorithms
              </li>
            </ul>
          </div>

          <div style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "15px",
            padding: "25px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
            borderLeft: "6px solid #2d8f5f",
            transition: "all 0.3s ease"
          }}>
            <h3 style={{
              color: "#1a5f3f",
              fontSize: "1.3em",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: 700
            }}>
              <span style={{ fontSize: "1.4em", color: "#2d8f5f" }}>📊</span>
              Analytics & Business Intelligence
            </h3>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Customer engagement analytics
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Search ranking insights
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Review and rating summaries
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Traffic and conversion tracking
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Competitive analysis tools
              </li>
            </ul>
          </div>

          <div style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "15px",
            padding: "25px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
            borderLeft: "6px solid #2d8f5f",
            transition: "all 0.3s ease"
          }}>
            <h3 style={{
              color: "#1a5f3f",
              fontSize: "1.3em",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: 700
            }}>
              <span style={{ fontSize: "1.4em", color: "#2d8f5f" }}>🎯</span>
              Customer Service Tools
            </h3>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Review response management
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Customer inquiry tracking
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Response time monitoring
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Dispute resolution system
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Customer feedback analytics
              </li>
            </ul>
          </div>

          <div style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            borderRadius: "15px",
            padding: "25px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
            borderLeft: "6px solid #2d8f5f",
            transition: "all 0.3s ease"
          }}>
            <h3 style={{
              color: "#1a5f3f",
              fontSize: "1.3em",
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontWeight: 700
            }}>
              <span style={{ fontSize: "1.4em", color: "#2d8f5f" }}>🛡️</span>
              Accountability & Transparency
            </h3>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Transparency scorecard (publicly visible)
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Quality compliance tracking
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Trust score calculation
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Improvement plan tracking
              </li>
              <li style={{
                color: "#444",
                marginBottom: "8px",
                paddingLeft: "20px",
                position: "relative",
                fontSize: "0.95em",
                lineHeight: 1.4
              }}>
                <span style={{
                  position: "absolute",
                  left: "0",
                  color: "#2d8f5f",
                  fontWeight: "bold"
                }}>✓</span>
                Industry standard compliance
              </li>
            </ul>
          </div>
        </div>

        <div style={{
          background: "linear-gradient(135deg, #2d8f5f 0%, #1a5f3f 100%)",
          color: "white",
          borderRadius: "20px",
          padding: "30px",
          margin: "30px 0",
          textAlign: "center"
        }}>
          <h2 style={{
            fontSize: "2em",
            marginBottom: "20px",
            color: "white"
          }}>🏆 Trusted Tester Program</h2>
          <p style={{
            fontSize: "1.2em",
            marginBottom: "20px"
          }}>Professional product testing that maintains integrity while providing credible feedback</p>
          
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            marginTop: "25px"
          }}>
            <div style={{
              background: "rgba(255, 255, 255, 0.1)",
              padding: "15px",
              borderRadius: "10px",
              backdropFilter: "blur(5px)"
            }}>
              <h4 style={{
                color: "#fff",
                marginBottom: "8px",
                fontSize: "1.1em"
              }}>ID-Verified Reviewers</h4>
              <p style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.9em",
                lineHeight: 1.4
              }}>Identity verification and background screening ensure authentic testers</p>
            </div>
            <div style={{
              background: "rgba(255, 255, 255, 0.1)",
              padding: "15px",
              borderRadius: "10px",
              backdropFilter: "blur(5px)"
            }}>
              <h4 style={{
                color: "#fff",
                marginBottom: "8px",
                fontSize: "1.1em"
              }}>Quality Assessment</h4>
              <p style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.9em",
                lineHeight: 1.4
              }}>Testers evaluated for clear, detailed, helpful review writing abilities</p>
            </div>
            <div style={{
              background: "rgba(255, 255, 255, 0.1)",
              padding: "15px",
              borderRadius: "10px",
              backdropFilter: "blur(5px)"
            }}>
              <h4 style={{
                color: "#fff",
                marginBottom: "8px",
                fontSize: "1.1em"
              }}>Honest Feedback Guarantee</h4>
              <p style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.9em",
                lineHeight: 1.4
              }}>Unbiased, truthful reviews - no pay-for-positive-reviews allowed</p>
            </div>
            <div style={{
              background: "rgba(255, 255, 255, 0.1)",
              padding: "15px",
              borderRadius: "10px",
              backdropFilter: "blur(5px)"
            }}>
              <h4 style={{
                color: "#fff",
                marginBottom: "8px",
                fontSize: "1.1em"
              }}>Direct Vendor Connection</h4>
              <p style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.9em",
                lineHeight: 1.4
              }}>Secure platform connects vendors with approved testers for sampling</p>
            </div>
            <div style={{
              background: "rgba(255, 255, 255, 0.1)",
              padding: "15px",
              borderRadius: "10px",
              backdropFilter: "blur(5px)"
            }}>
              <h4 style={{
                color: "#fff",
                marginBottom: "8px",
                fontSize: "1.1em"
              }}>Transparent Process</h4>
              <p style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.9em",
                lineHeight: 1.4
              }}>All reviews clearly marked and tracked for integrity</p>
            </div>
            <div style={{
              background: "rgba(255, 255, 255, 0.1)",
              padding: "15px",
              borderRadius: "10px",
              backdropFilter: "blur(5px)"
            }}>
              <h4 style={{
                color: "#fff",
                marginBottom: "8px",
                fontSize: "1.1em"
              }}>Cost-Effective</h4>
              <p style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "0.9em",
                lineHeight: 1.4
              }}>Reasonable fees for professional testing vs expensive marketing</p>
            </div>
          </div>
        </div>

        <div style={{
          background: "linear-gradient(135deg, #1a5f3f 0%, #2d8f5f 100%)",
          color: "white",
          padding: "25px",
          borderRadius: "15px",
          textAlign: "center",
          marginTop: "30px"
        }}>
          <h3 style={{
            fontSize: "1.6em",
            marginBottom: "10px"
          }}>Ready to Elevate Your Vendor Standards?</h3>
          <p style={{
            fontSize: "1.1em",
            marginBottom: "15px"
          }}>Join the platform that's setting the new industry standard for quality, transparency, and customer trust.</p>
          <a href="#" style={{
            background: "white",
            color: "#1a5f3f",
            padding: "12px 30px",
            borderRadius: "25px",
            textDecoration: "none",
            fontWeight: 600,
            display: "inline-block",
            marginTop: "10px",
            transition: "all 0.3s ease"
          }}>Get Started Today</a>
        </div>
      </div>
    </div>
  )
}

export default VendorBenefitsMailer